<template>
	<div class="detail-product-tab d-flex space-between">
		<div
			:class="[disabledProduct ? 'wrapper-related' : 'wrapper-possibly-like']"
			v-if="products.length">
			<div class="possibly-title">Posiblemente te gusten:</div>
			<div :class="{ 'card-product-wrapper': disabledProduct }">
				<card-product-big
					:class="{ 'card-product': disabledProduct }"
					v-for="product in products" 
					:key="product.id"
					:product="product"
					:hide-heart="true"
				/>
			</div>
		</div>
		<tabs-product 
			v-if="!disabledProduct"
			class="wrapper-tabs"
			:class="{'width-full':!products.length}"
			:data="tabs"
			@select="selectTab"
			>
				<div v-if="select">
					<div v-if="select.flag === 'questions'">
						<form-questions @update="updateQuestion" :id="id"/>
						<wrapper-answer 
							:data="question" 
							v-for="question in listQuestions"
							:key="question.id"
							class="mb-3"/>
					</div>
					<div v-if="select.flag === 'opinions'">
						<wrapper-opinion 
							:id="id"
							:opinions="listOpinions"
						/>
					</div>
					<div v-if="select.flag === 'service'">
						<content-text
							:content="subSection"
							v-for="subSection in select.subSections"
							:key="subSection.id"
						/>
					</div>
				</div>
		</tabs-product>
		<tabs-product-mobile
			:data="tabs"
			class="wrapper-tabs-mobile"
			@select="selectTab"
			:list-questions="listQuestions"
			:opinions="listOpinions"
			:select="select"/>
		<div class="wrapper-possibly-like-mobile">
			<div
				:style="`background-color:${globalColors.primary}`"
				class="possibly-title-mobile txt-center"
			>POSIBLEMENTE TE GUSTE</div>
			<div class="wrapper-slider-possibly">
				<swiper :options="swiperOption">
					<swiper-slide
						class="d-flex"
						v-for="product in products" 
						:key="product.id"
					>
						<card-product-big	:product="product"/> 
					</swiper-slide>
				</swiper>
			</div>
		</div>
	</div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import cardProductBig from '@/components/cardProductBig';
import tabsProduct from '@/components/tabsProduct';
import tabsProductMobile from '@/components/tabProductMobile';
import formQuestions from '@/components/detail/formQuestions';
import questions from '@/components/detail/questions';
import wrapperAnswer from '@/components/detail/wrapperAnswer';
import wrapperOpinion from '@/components/detail/wrapperOpinions';
import contentText from '@/components/detail/content';

function data() {
	return {
		swiperOption: {
			slidesPerView: 3,
			spaceBetween: 30,
			slidesPerColumn: 2,
			breakpoints: {
				900: {
					slidesPerView: 3,
				},
				800: {
					slidesPerView: 2,
				},
				644: {
					slidesPerView: 1,
				},
			},
		},
	};
}

function selectTab(tab, active) {
	this.$emit('select', tab, active);
}

function updateQuestion() {
	this.$emit('update');
}

export default {
	name: 'tabs-product-general',
	data,
	components: {
		cardProductBig,
		swiper,
		swiperSlide,
		tabsProduct,
		tabsProductMobile,
		formQuestions,
		questions,
		wrapperAnswer,
		wrapperOpinion,
		contentText,
	},
	methods: {
		selectTab,
		updateQuestion,
	},
	props: {
		products: {
			type: Array,
			default: () => [],
		},
		disabledProduct: {
			type: Boolean,
			required: true,
		},
		tabs: {
			type: Array,
			default: () => [],
		},
		select: {
			type: Object,
			default: () => {},
		},
		listQuestions: {
			type: Array,
			default: () => [],
		},
		listOpinions: {
			type: Array,
			default: () => [],
		},
		id: [Number, String],
	},
};
</script>
<style lang="scss" scoped>
	.detail-product-tab {
		padding: 0 5%;
	}

	.wrapper-possibly-like {
		border: 0.2rem solid color(border-grey);
		padding: 2.8rem 2.2rem;
		width: 26.7rem;
	}

	.possibly-title {
		font-family: font(open-bold);
		font-size: size(medium);
		margin: 0 0 2rem 3rem;
	}

	.wrapper-possibly-like-mobile {
		display: none;
	}

	.wrapper-tabs {
		margin-left: 1rem;
		width: calc(100% - 31.5rem);
	}

	.wrapper-tabs-mobile {
		display: none;
	}

	.wrapper-tabs {
		display: block;

		&.width-full {
			width: 100%;
		}
	}

	@media screen and (max-width: 1024px) {
		.detail-product-tab {
			flex-direction: column;
			padding: 0;
		}

		.wrapper-possibly-like {
			display: none;
		}

		.wrapper-possibly-like-mobile {
			display: block;
			position: relative;
		}

		.possibly-title-mobile {
			color: white;
			font-family: font(open-semibold);
			font-size: size(maxmedium);
			left: 0;
			margin-bottom: 2rem;
			padding: 0.5rem 0;
		}

		.wrapper-slider-possibly {
			padding: 0 5%;
		}

		.wrapper-tabs-mobile {
			display: block;
		}

		.wrapper-tabs {
			display: none;
		}
	}

	.wrapper-related {
		display: none;
		@media (min-width: 1024px) {
			display: block;
			width: fit-content;
		}
	}

	.card-product-wrapper {
		display: flex;
		flex-wrap: wrap;
		margin: 0 20px;
	}

	.card-product {
		width: 26.7rem;
	}
</style>



// WEBPACK FOOTER //
// tabs.vue?36e462cf